import { z } from "zod";

/**
 * Validates an API response, failing with something a person can act on.
 *
 * `schema.parse()` throws a `ZodError` whose `message` is a JSON dump of every
 * issue it found. Nothing between the call site and the global error handler
 * narrows that, so the dump reached the user verbatim — the same way a raw
 * JavaScriptCore parser message did, and just as unreadable at a reception desk.
 *
 * The issue list is genuinely useful, so it goes to the console with the payload
 * beside it; only the thrown message is shortened.
 *
 * Throws rather than returning a result object: every caller already sits inside
 * a try/catch that classifies auth and network failures, and a malformed
 * response belongs on that same path. Returning a result here would mean editing
 * five call sites to branch on something they already handle by catching.
 */
export function parseAPIResponse<Schema extends z.ZodTypeAny>(
	schema: Schema,
	payload: unknown,
	context: string,
): z.infer<Schema> {
	const result = schema.safeParse(payload);

	if (!result.success) {
		console.error(`Phản hồi API sai cấu trúc (${context}):`, result.error.issues, payload);
		throw new Error(`Phản hồi từ máy chủ không đúng định dạng (${context})`);
	}

	return result.data;
}
